import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { UpdateSuspensionConfigDto } from '@control-center/shared';

import {
  fetchSuspensionConfig,
  setClientSuspensionOptOut,
  setSaasAutoSuspension,
  updateSuspensionConfig,
} from '../lib/suspension-policy-api';

export const suspensionPolicyKeys = {
  all: ['suspension-policy'] as const,
  config: () => [...suspensionPolicyKeys.all, 'config'] as const,
};

export function useSuspensionConfig(enabled = true) {
  return useQuery({
    queryKey: suspensionPolicyKeys.config(),
    queryFn: fetchSuspensionConfig,
    staleTime: 30_000,
    enabled,
  });
}

export function useUpdateSuspensionConfig() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (dto: UpdateSuspensionConfigDto) => updateSuspensionConfig(dto),
    onSuccess: (config) => {
      qc.setQueryData(suspensionPolicyKeys.config(), config);
    },
  });
}

export function useSetClientSuspensionOptOut() {
  return useMutation({
    mutationFn: ({ clientId, skip }: { clientId: string; skip: boolean }) =>
      setClientSuspensionOptOut(clientId, skip),
  });
}

export function useSetSaasAutoSuspension() {
  return useMutation({
    mutationFn: ({ saasProductId, enabled }: { saasProductId: string; enabled: boolean }) =>
      setSaasAutoSuspension(saasProductId, enabled),
  });
}
